import React from 'react';
import {useTranslation} from 'react-i18next';
import EzManageNavContext from './EzManageNavContext';

type EzManageNavProviderProps = {
  appName: string;
  children: React.ReactNode;
};

const EzManageNavProvider: React.FC<EzManageNavProviderProps> = ({appName, children}) => {
  const {t: useMessage} = useTranslation();
  return (
    <EzManageNavContext.Provider
      value={{
        appName,
        useMessage,
      }}
    >
      {children}
    </EzManageNavContext.Provider>
  );
};

export default EzManageNavProvider;
